import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6283724c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6283724c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../resource-manage/node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6283724c",
  null
  
)

export default component.exports